/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const BoxInput = ({
  type,
  handleKeyDown,
  handleChange,
  handleFocus,
  handleBlur,
  handleKeyUp,
  name,
  inputRef,
}) => (
  <input
    type={type}
    onKeyDown={handleKeyDown}
    onChange={handleChange}
    onFocus={handleFocus}
    onBlur={handleBlur}
    onKeyUp={handleKeyUp}
    className="border-bottom border-0 border-shadow text-bold text-center text-f4 d-flex flex-row justify-content-center align-items-center box-input bg-transparent text-dark"
    name={name}
    ref={inputRef}
    style={{ width: '2.5rem', height: '3rem', outline: 'none' }}
  />
);

BoxInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleKeyUp: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
};

export default BoxInput;
